import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const BASE_CONSUMER_URL = `${BASE_URL}api/consumers/`;

const ConsumerService = () => ({

	getConsumers: async () => {
		const { data } = await axios.get(`${BASE_CONSUMER_URL}`);
		return data;
	},
	getConsumer: async (id) => {
		const { data } = await axios.get(`${BASE_CONSUMER_URL}${id}`);
		return data;
	},
	createConsumerConfiguration: async (id, configs) => {
		const { data } = await axios.post(`${BASE_CONSUMER_URL}${id}/Configurations`, configs);
		return data;
	},
	editConsumerConfiguration: async (id, configs) => {
		const { data } = await axios.put(`${BASE_CONSUMER_URL}${id}/Configurations`, configs);
		return data;
	},
	bulkEditConsumerConfiguration: async (configs) => {
		const { data } = await axios.post(`${BASE_CONSUMER_URL}Bulk`, configs);
	},
	bulkEditAllConsumerConfiguration: async (configs) => {
		const { data } = await axios.post(`${BASE_CONSUMER_URL}Bulk/All`, configs);
	}
});

export default ConsumerService;